/* eslint no-console:0 */
// This is the entrypoint for the `roxyhotel` child theme. The files
// imported here will be included on every page of the roxyhotel website.
//
// To reference this file, add <%= javascript_pack_tag 'roxyhotel' %> to the appropriate
// layout file, like frontend/roxyhotel/layouts/application.haml

import 'shared/assets/css'
import 'hotels/assets/css'
import 'hotels/components'
import 'shared/components'
import './css'
import './javascript'
